import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { log } from '../../../util/log';
import { routeToString } from '../../../util/routes';
import { V2Route, V3Route } from '../../router';
export function computeAllV3Routes(tokenIn, tokenOut, pools, maxHops) {
  return computeAllRoutes(tokenIn, tokenOut, function (route, tokenIn, tokenOut) {
    return new V3Route(route, tokenIn, tokenOut);
  }, pools, maxHops);
}
export function computeAllV2Routes(tokenIn, tokenOut, pools, maxHops) {
  return computeAllRoutes(tokenIn, tokenOut, function (route, tokenIn, tokenOut) {
    return new V2Route(route, tokenIn, tokenOut);
  }, pools, maxHops);
}
export function computeAllRoutes(tokenIn, tokenOut, buildRoute, pools, maxHops) {
  var poolsUsed = Array(pools.length).fill(false);
  var routes = [];

  var computeRoutes = function computeRoutes(tokenIn, tokenOut, currentRoute, poolsUsed, _previousTokenOut) {
    if (currentRoute.length > maxHops) {
      return;
    }

    if (currentRoute.length > 0 && currentRoute[currentRoute.length - 1].involvesToken(tokenOut)) {
      routes.push(buildRoute(_toConsumableArray(currentRoute), tokenIn, tokenOut));
      return;
    }

    for (var i = 0; i < pools.length; i++) {
      if (poolsUsed[i]) {
        continue;
      }

      var curPool = pools[i];
      var previousTokenOut = _previousTokenOut ? _previousTokenOut : tokenIn;

      if (!curPool.involvesToken(previousTokenOut)) {
        continue;
      }

      var currentTokenOut = curPool.token0.equals(previousTokenOut) ? curPool.token1 : curPool.token0;
      currentRoute.push(curPool);
      poolsUsed[i] = true;
      computeRoutes(tokenIn, tokenOut, currentRoute, poolsUsed, currentTokenOut);
      poolsUsed[i] = false;
      currentRoute.pop();
    }
  };

  computeRoutes(tokenIn, tokenOut, [], poolsUsed);
  log.info({
    routes: routes.map(routeToString)
  }, "Computed ".concat(routes.length, " possible routes."));
  return routes;
}